import React from "react";
import { useTranslation } from "react-i18next";
import { Row, Col, Flex } from "antd";
import { Widget } from "../../../../Atomics/Widget";

export const BuildingProductionEnergy = () => {
  const { t } = useTranslation();

  return (
    <Row id="Average Consumption" gutter={[16, 16]}>
      <Col span={6}>
        <Flex gap={16} vertical="true">
          <Widget
            data={{
              height: "150px",
              background: "white",
              title: t("Average Consumption"),
              icon: "Bolt",
              charts: [
                {
                  chartType: "bigNumberChart",
                  data: {
                    number: "150.7",
                    unit: "kWh",
                    type: null,
                    label: null,
                    fluctuation: null,
                    fluctuationText: "fluctuation ",
                    bigFluctuation: false,
                    icon: "Bolt",
                  },
                  height: '80px',
                },
              ],
            }}
          />
          <Widget
            data={{
              height: "150px",
              background: "white",
              title: t("Maximum Consumption"),
              icon: "Bolt",
              charts: [
                {
                  chartType: "bigNumberChart",
                  data: {
                    number: "160.4",
                    unit: "kWh",
                    type: null,
                    label: null,
                    fluctuation: null,
                    fluctuationText: "fluctuation ",
                    bigFluctuation: false,
                    icon: "Bolt",
                  },
                  height: '100%',
                },
              ],
            }}
          />
        </Flex>
      </Col>
      <Col span={18}>
        <div /* ref={electricityConsumePowerRef} */>
          <Widget
            data={{
              height: "300px",
              background: "white",
              title: t("Average Consumption days of the week"),
              icon: "Bolt",
              charts: [
                {
                  chartType: "columnsChartApex",
                  height: '255px',
                  data: {
                    series: [
                      {
                        name: 2024,
                        data: [
                          {
                            x: "Mon",
                            y: "158.0",
                          },
                          {
                            x: "Tue",
                            y: "160.4",
                          },
                          {
                            x: "Wed",
                            y: "157.0",
                          },
                          {
                            x: "Thu",
                            y: "157.5",
                          },
                          {
                            x: "Fri",
                            y: "154.5",
                          },
                          {
                            x: "Sat",
                            y: "133.6",
                          },
                          {
                            x: "Sun",
                            y: "134.1",
                          },
                        ],
                        unit: "kWh",
                      },
                    ],
                    categories: [],
                    xAxisType: null,
                    labelFormat: null,
                    tooltip: null,
                    unit: "kWh",
                    columnWidth: 20,
                    xAxisLabel: null,
                    yAxisLabel: "kWh",
                    colors: null,
                    filename: "Gráfico exportado",
                    headerValue: "valores",
                    headerCategory: "categorias",
                  },
                },
              ],
            }}
            municipalitiesToFetch="Porto"
          />
        </div>
      </Col>
    </Row>
  );
};
